import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudio = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2202_18493)",
			children: /* @__PURE__ */ _jsx("path", { d: "M15.5066 2.00941L7.48487 3.64706C7.28866 3.68471 7.14721 3.86824 7.15177 4.0753V14.3106C6.47644 13.9435 5.68704 13.8682 4.96153 14.1082C4.35008 14.2776 3.80709 14.64 3.4101 15.1482C3.05419 15.5765 2.92186 16.16 3.05419 16.7059C3.27321 17.5059 4.11737 18 5.10754 18C5.4087 18 5.71442 17.9576 6.00189 17.8682C7.01031 17.5812 7.79059 16.8094 7.9366 15.9718C7.96855 15.8118 7.98223 15.6518 7.97767 15.4918V7.35059L15.169 5.81647V12.6024C14.4936 12.2353 13.7042 12.16 12.9787 12.4C11.6418 12.7953 10.7885 13.9624 11.076 14.9976C11.295 15.7976 12.1391 16.2918 13.1293 16.2918C13.4305 16.2918 13.7362 16.2494 14.0237 16.16C15.0321 15.8729 15.8124 15.1012 15.9584 14.2635C15.9812 14.1318 15.9949 14 15.9994 13.8682V2.43765C15.9994 2.31059 15.9492 2.18353 15.8489 2.10353C15.753 2.01883 15.6253 1.98588 15.5021 2.01412L15.5066 2.00941Z" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2202_18493",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13,
				height: 16,
				fill: "white",
				transform: "translate(3 2)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAudio);
export default ForwardRef;
